import { operationActions } from 'apps/builder/store/reducers/entities/operations'
export const {
  addOperation,
  deleteOperation,
  updateOperation,
} = operationActions
import { guidNumber } from 'apps/builder/lib/utils'

export const createOperation = ({
  guid,
  id,
  operation_type_id = 1,
  operation_type = 'add',
  ...operationData
}) => {
  return addOperation({
    ...operationData,
    entry: guid,
    entry_id: id,
    operation_type_id,
    operation_type,
    id: guidNumber(),
  })
}
